// Standard library imports
import React, { useState } from 'react';
// External library imports
import { Calendar } from 'react-date-range';
import moment from 'moment';
import { UilSchedule } from '@iconscout/react-unicons';

// Internal module imports
import ModalComponent from '../../ModalComponent/ModalComponent';

// Css imports
import classes from './DatePicker.module.css';
import { momentTimeFormater } from '../../../utils/dateHelper';

const today = momentTimeFormater().startOf('day').toDate();

const DatePicker = ({ date, setDate, disabled, showArrow = true, size, disableFutureDate = true, ...props }) => {
    const [showCalender, setShowCalender] = useState(false);
    const handleSelect = (date) => {
        const currentTime = moment();
        const updatedDate = moment(date).hour(currentTime.hour()).minute(currentTime.minute()).second(currentTime.second());

        setDate(updatedDate.toDate());
        setShowCalender(false);
    };
    const handleBackClick = () => {
        const previousDay = moment(date).subtract(1, 'day');
        setDate(previousDay.toDate());
    };

    const handleNextClick = () => {
        const nextDay = moment(date).add(1, 'day');
        if (disableFutureDate && moment(nextDay).startOf('day').isAfter(today)) return;
        setDate(nextDay.toDate());
    };

    const isNextDisabled = disableFutureDate && date && moment(date).add(1, 'day').startOf('day').isAfter(today);
    
    return (
        <div>
            <div className={classes.DatePickerContainer} style={disabled ? { opacity: '0.5' } : {}}>
                {showArrow && (
                    <div className={`${classes.ArrowButton} ${size === 'large' ? classes.Large : ''}`} onClick={() => !disabled && handleBackClick()}>
                        {'<'}
                    </div>
                )}
                <div className={`${classes.DateContainer} ${size === 'large' ? classes.Large : ''}`} onClick={() => !disabled && setShowCalender(!showCalender)}>
                    <div className={classes.Date}>{date && moment(date).format('MMMM DD')}</div>
                    <div className={classes.CalendarIcon}>
                        <UilSchedule style={{ color: 'var(--color-primary)' }} size={'1.042vw'} />
                    </div>
                </div>
                {showArrow && (
                    <div
                        className={`${classes.ArrowButton} ${size === 'large' ? classes.Large : ''} ${isNextDisabled ? classes.DisabledArrow : ''}`}
                        onClick={() => !disabled && handleNextClick()}
                    >
                        {'>'}
                    </div>
                )}
            </div>

            {showCalender && (
                <ModalComponent isOpen={showCalender} setOpen={setShowCalender}>
                    <Calendar
                        className={classes.CalendarPopUp}
                        date={moment(date).toDate()}
                        maxDate={disableFutureDate ? today : undefined}
                        onChange={handleSelect}
                        autoFocus={false}
                        color="var(--color-primary)"
                        fixedHeight={true}
                    />
                </ModalComponent>
            )}
        </div>
    );
};

export default DatePicker;
